import Button from '@ui/Button';
import Input from '@ui/Input';
import TextArea from '@ui/TextArea';
import React from 'react';
import * as yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import Typography from '@ui/Typography';
import { defaults, pick } from 'lodash-es';
import StyledButtonNew from 'components/Styled/StyledButtonNew';
import StyledContainedButton from '../../Styled/StyledContainedButton';

const schema = yup.object().shape({
  about: yup.string().max(255, 'About must be less than 255 characters'),
  // .required('About is required'),
});

function EditProfileAboutStep(props) {
  const { userProfile, onSubmit, onBack, formData, onNext, saving } = props;

  const defaultValues = defaults(pick(formData, ['about']), {
    about: userProfile ? userProfile.about : '',
  });

  const form = useForm({
    defaultValues: defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema),
  });

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    watch,
    trigger,
  } = form;

  const handleFormSubmit = async (data) => {
    onSubmit(data, 'About');
    // onNext();
  };

  return (
    <div className="flex flex-col gap-12 flex-1 w-full">
      <form
        onSubmit={handleSubmit(handleFormSubmit)}
        className="flex flex-col gap-6">
        <Controller
          name="about"
          control={control}
          render={({ field: { ref, ...rest } }) => (
            <TextArea
              label="ABOUT"
              placeholder=""
              multiline="true"
              rows={6}
              {...rest}
              error={errors.about?.message}
            />
          )}
        />

        <div className="flex justify-end flex-rows gap-4">
          {/* <div className="flex-flow-col">
            <Button
              variant="outlined"
              color="primary"
              className="mt-2"
              onClick={onBack}>
              Back
            </Button>
          </div> */}
          {isValid ? (
            <div className="flex-flow-col">
              <StyledContainedButton
                variant="filled"
                color="primary"
                type="submit"
                className="mt-2"
                loading={saving}
                // onClick={onNext}
              >
                Save
              </StyledContainedButton>
            </div>
          ) : (
            <div className="flex-flow-col">
              <StyledContainedButton
                disabled={true}
                variant="outlined"
                color="primary"
                type="submit"
                className="mt-2"
                // onClick={onNext}
              >
                Save
              </StyledContainedButton>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}

export default EditProfileAboutStep;
